"use client";

import { useEffect, useRef, useState } from "react";
import { Building2, Activity, Users, LaptopMinimal } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
function useRevealOnScroll<T extends HTMLElement = HTMLDivElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
} = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) observer.unobserve(entry.target);
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const trustPoints = [{
  title: "UK Registered Charity",
  description: "We are a registered UK charity committed to transparency, accountability, and meaningful support for education and community development in Ghana.",
  icon: Building2
}, {
  title: "Clear Impact",
  description: "Every donation helps support practical projects that improve access to education, learning environments, and opportunity for children and communities.",
  icon: Activity
}, {
  title: "Trusted Leadership",
  description: "Our trustees and leadership team are committed to responsible governance and ensuring support reaches the communities we serve.",
  icon: Users
}, {
  title: "Transparent Giving",
  description: "We value openness and responsible stewardship, giving donors confidence that their support is used carefully and purposefully.",
  icon: LaptopMinimal
}];
export default function WhoIsTomorrowFor() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}